import { JSONUtilites } from '../../../helpers/JSONUtilites';
import { ProductPricelistItem } from './product-pricelist-item';

export class PricelistVersion {
  id: number;
  name: string;
  dateStart: Date;
  dateEnd: Date;
  productPricelistItems: ProductPricelistItem[] = [];

  constructor() { }

  static arrayFromJSON(json: string): PricelistVersion[] {
    const values = JSON.parse(json);
    if (!values || !Array.isArray(values)) {
      return null;
    }

    const result: PricelistVersion[] = [];
    for (const item of values) {
      result.push(PricelistVersion.createFromAny(item));
    }

    return result;
  }

  static createFromAny(object: any): PricelistVersion {
    if (object === null || object === undefined) {
      return null;
    }
    const pricelistVersion = new PricelistVersion();
    pricelistVersion.id = object.id;
    pricelistVersion.name = object.name;
    pricelistVersion.dateStart = object.dateStart;
    pricelistVersion.dateEnd = object.dateEnd;
    pricelistVersion.productPricelistItems = object.productPricelistItems ? object.productPricelistItems.map(x => ProductPricelistItem.createFromAny(x)) : new Array<ProductPricelistItem>();

    return pricelistVersion;
  }

  toJSON(): any {
    return {
      id: this.id,
      name: this.name,
      dateStart: this.dateStart,
      dateEnd: this.dateEnd,
      productPricelistItems: this.productPricelistItems,
    };
  }
}
